import { flexRow, truncateMultiline } from '@anm/styles/helpers';
import styled from 'styled-components';

export const ListWrapper = styled.div`
  overflow: auto;
  padding: 0 24px;
  margin-top: 20px;
  max-height: 300px;
  width: calc(100% + 84px);
  border-top: 1px solid rgba(0, 56, 87, 0.2);
  border-bottom: 1px solid rgba(0, 56, 87, 0.2);
`;

export const ProjectLink = styled.a`
  ${flexRow};
  margin: 8px 0;
  text-decoration: none;
`;

export const ProjectPreview = styled.div<{ src: string }>`
  width: 75px;
  height: 42px;
  min-width: 75px;
  margin-right: 16px;
  background: url(${({ src }) => src}) center / contain no-repeat;
`;

export const Title = styled.div`
  color: #000;
  width: 100%;
  font-weight: bold;
  min-height: 19.5px;
  margin-bottom: 2px;
  span {
    text-align: left;
    ${truncateMultiline(1)};
  }
`;

export const Time = styled.p`
  margin: 0;
  width: 100%;
  color: #919eaa;
  font-size: 14px;
  text-align: left;
`;
